import { PortalLoginSection, saved_portal_username } from "../portal_login_section"
import { HEB_PORTAL_URL } from "./upload_section"

/** The portal login already saved on the integration, if any. */
export function saved_heb_portal_username(username: string | null | undefined): string | null {
  return saved_portal_username(username)
}

interface HebCredentialsSectionProps {
  /** `integration.username` of the org's `heb` row, when it has one. */
  username?: string | null
  onSaved: () => void
  className?: string
}

/**
 * Save the brand's AP-AR Application login on its `heb` integration. With it saved, we pull the
 * payment export every weekday: H-E-B emails a verification code at each sign-in, and the sync
 * reads it from the brand's connected mailbox.
 */
export function HebCredentialsSection({ username, onSaved, className }: HebCredentialsSectionProps) {
  return (
    <PortalLoginSection
      integration_name="heb"
      portal_label="H-E-B portal"
      username={username}
      onSaved={onSaved}
      className={className}>
      <p class="text-sm text-gray-500">
        The login you use at{" "}
        <a href={HEB_PORTAL_URL} target="_blank" rel="noopener noreferrer" class="text-blue-700 hover:underline">
          avp.heb.com
        </a>
        . Once it's saved we pull your H-E-B payments every weekday. H-E-B emails a verification code to this address at
        each sign-in, and we read it from your connected mailbox — so make sure the inbox that receives H-E-B's emails is
        connected under Email.
      </p>
    </PortalLoginSection>
  )
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("saved_heb_portal_username", () => {
    it("treats the mailbox-only placeholder as no login", () => {
      expect(saved_heb_portal_username("default")).toBeNull()
      expect(saved_heb_portal_username("")).toBeNull()
      expect(saved_heb_portal_username(undefined)).toBeNull()
      expect(saved_heb_portal_username(" ar@brand.com ")).toBe("ar@brand.com")
    })
  })
}
